import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Navigate } from "react-router-dom";
import { logout } from "../../app/features/auth/authActions";

const Logout = () => {
  const isAuthenticated = useAppSelector(state => state.auth.isAuthenticated);
  const dispatch = useAppDispatch();

  if (!isAuthenticated) {
    return (
      <Navigate to="/" />
    );
  }
  
  dispatch(logout());

  return (
    <div>
      Please wait...
    </div>
  );
};

export default Logout;
